import React from 'react';
import ProjectCard from '@components/ProjectCard';
import FlapBoard from '@components/FlapBoard';
import portfolioItems from './portfolio-items';

import './style.scss';

const PROJECTS_ROW = [
  {
    text:   'PROJECTS',
    colors: ['purple','purple','purple','purple','purple','purple','purple','purple'],
  },
];

const PortfolioPage = () => {
  return (
    <div id="projects" className="portfolio-page">
      <div className="content-grid">
        <FlapBoard heading="h2" autoPlay={false} rows={PROJECTS_ROW} />
        <div className="portfolio-wrapper">
          {portfolioItems.map((item, i) => (
            <ProjectCard project={item} index={i} key={item.name} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PortfolioPage;



// WEBPACK FOOTER //
// ./src/pages/PortfolioPage/PortfolioPage.js